import { useState as t, useEffect as v } from "react";
import { isInDebugMode as i } from "../helpers/debug-helper.js";
function L(n) {
  const [P, h] = t(void 0), [m, p] = t(void 0), [W, a] = t(!1), [e, s] = t(void 0), [G, r] = t(!1);
  let c = -1;
  v(() => (navigator && navigator.permissions && navigator.permissions.query && navigator.permissions.query({ name: "geolocation" }).then((o) => {
    i() && console.log(o), s(o.state), o.onchange = (u) => {
      if (u.type === "change") {
        i() && console.log(o);
        const y = u.target.state;
        s(y);
      }
    };
  }), () => {
    d();
  }), []), v(() => {
    (e === "granted" || e === "denied") && (G || f());
  }, [e]);
  const g = (o) => {
    i() && console.log(o), h({
      lat: o.coords.latitude,
      lng: o.coords.longitude
    }), r(!0), a(!1);
  }, l = (o) => {
    i() && console.error(o), a(!1), p(o);
  }, f = () => {
    navigator.geolocation && (a(!0), navigator.geolocation.getCurrentPosition(g, l, n), c = navigator.geolocation.watchPosition(g, l, n));
  }, d = () => {
    navigator.geolocation && (navigator.geolocation.clearWatch(c), r(!1));
  };
  return {
    geolocation: P,
    isLoadingGeolocation: W,
    error: m,
    permissionStatus: e,
    startWatchPosition: f,
    stopWatchPosition: d
  };
}
export {
  L as useGeolocation
};
